import React from 'react';
import TableAddEdit from './TableAddEdit';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Popup from './Popup.js';
import db from './db';
import SearchPopupButton from './SearchPopupButton';
import SearchTable from './SearchTable.js';
var functions = require("./functions.js");
var tae = require("./TableAddEdit.js");
var TableColumnRender= require( "./TableColumnRender.js");

// DeviceTable component
export default class DeviceTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);
        this.deviceTableRef = React.createRef();
        this.shipTableRef = React.createRef();
        let device_type_list=[];
        let cols=[];
        try{
            device_type_list=JSON.parse(this.props.securityObject.systemSettings.device_type_list_hubspot);
            cols.push({ key: 'facility_name', noquery:true, title:"facility name" , noedit:true});
            cols.push({ key: 'hostname', noquery:true, title:"hostname" , noedit:true});
            cols.push({ key: 'hub_display_name', noquery:true, title:"hub name" , noedit:true});
            cols.push({ key: 'mac', noquery:true, title:"mac", width:50 } );
            cols.push({ key: 'serial_number', noquery:true, title : "serial", width :20});
            cols.push({ key: 'ip', noquery:true, title : "ip", width :20, noedit:true,render:TableColumnRender.renderNoteSimple});
            cols.push({ key: 'type', title:"type", noquery:true, width:30, options: device_type_list} ); 
            cols.push({ key: 'last_updated_time', title:"last update", noquery:true, noedit:true, width:30} ); 
            cols.push({ key: 'firmware_version', noquery:true, title:"firmware version", editClassName:"hidden", width :40 });
            cols.push({ key: 'note', title : "note", noquery:true, width :20, memo:true,editClassName:"line-note-4" });  
            cols.push({ key: 'id', title:"id", width:10 , noquery:true, noedit:true, editClassName:"hidden"} );
            cols.push({ key: 'facility_id', title:"facility id", editClassName:"hidden"});
            cols.push({ key: 'hub_id', title:"hub id", editClassName:"hidden"});
            cols.push({ key: 'search_column', title:"Search", noedit:true, doNotDisplayInTable:true});
        } catch (ex){}        
        this.state={
            device_type_list:device_type_list,
            postObj:[],
            edited:false,
            selectedObject:false,
            columns:cols,
            facilities:[],
            facilityId:false
        };

    }
    componentDidMount(prevProps) {
        if(this.props.facilityId){
            document.getElementById("searchTableInputfacility_id").value=this.props.facilityId;
            document.getElementById("searchTableInputfacility_id").readOnly=true;
            this.deviceTableRef.current.queryData();
        }  
        if(this.props.search){
            document.getElementById("searchTableInputsearch_column").value=this.props.search;
            document.getElementById("searchTableInputsearch_column").readOnly=true;
            this.deviceTableRef.current.queryData();
        }          
        //document.getElementById("labelTableInputfacility_id").className="hidden"    
        //document.getElementById("searchTableInputfacility_id").className="hidden"
        //document.getElementById("labelTableInputfacility_id").style.width="2px";
        //document.getElementById("searchTableInputfacility_id").style.width="2px";
        
    }
    // render
    render() {
        let qry="api/get/device?";  
        let update="api/updateDevice";
        return (true)?(
            <div className='relative-div'>
                <TableAddEdit
                    queryURL={qry}
                    updateURL={update}
                    columns={this.state.columns}
                    securityObject={this.props.securityObject}
                    tableHeight="70vh"
                    key="tableAddEditTableAddEdit"
                    showEditScreen={this.showEditScreen.bind(this)}
                    ref={this.deviceTableRef}
                >
                </TableAddEdit>
                <div className="device-buttons">
                    <button onClick={() => this.downloadCSV()} >Export CSV</button>
                    <SearchPopupButton 
                                    securityObject={this.props.securityObject}
                                    buttonLabel="Move Device to this Facility"
                                    query={this.props.securityObject.httpServer + "api/get/device?"}
                                    columns={[
                                            { key: 'facility_name', title:"facility", width :40 }
                                            ,{ key: 'mac', title:"mac", width :40 }
                                            ,{ key: 'serial_number', title:"serial number", width :40 }
                                            ,{ key: 'firmware_version', title:"firmware version", width :40 }
                                            ]}
                                    onClick={this.selectDeviceToMoveHere.bind(this)}
                                    hidden={!this.props.facilityId}
                                >
                    </SearchPopupButton>                        
                </div>
                <Popup trigger={this.state.selectedObject} afterClose={this.afterClosePopup.bind(this)}>
                    Device:{this.state.selectedObject.device_name}
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div>                     
                    <Tabs onSelect={(index)=>{
                        if (index=1){
                            //this.shipTableRef.current.queryData();                            
                        }
                    }}>
                        <TabList>
                            <Tab>Device</Tab>
                            <Tab>Shipments</Tab>
                        </TabList>                    
                        <TabPanel >
                            <div className='relative-div'>
                                <table>
                                    <tr>
                                        <td width={"760px"} className='plain'>
                                            <div style={{height:"50vh"}}>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.saveChanges()}>
                                                                <b>Save (alt-s)</b><br />
                                                                <img alt='save' src={ process.env.PUBLIC_URL +"/BarcodeSave.bmp"}></img>
                                                            </button>
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.saveChangesAdd()}>
                                                                Save/Add(alt-a)<br />
                                                                <img alt='SaveAdd' src={ process.env.PUBLIC_URL +"/BarcodeSaveAdd.bmp"}></img>
                                                            </button>
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.closePopup()}>
                                                                Cancel(alt-c)<br />
                                                                <img alt='cancel' src={ process.env.PUBLIC_URL +"/BarcodeCancel.bmp"}></img>
                                                            </button>  
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.removeData()}>
                                                                Remove Data(alt-r)<br />
                                                                <img alt='RemoveData' src={ process.env.PUBLIC_URL +"/BarcodeRemoveData.bmp"}></img>
                                                            </button> 
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => null}>
                                                                Enter<br />
                                                                <img alt='enter' src={ process.env.PUBLIC_URL +"/BarcodeEnter.bmp"}></img>
                                                            </button> 
                                                        </span>                                <br />  
                                                <span id="message" style={ {color:"red"} }></span>
                                                <br /> 
                                                <br />
                                                <br />

                                                {tae.getEditScreen(
                                                    this.state.columns
                                                    , this.state.selectedObject
                                                    , this.changeFieldValue.bind(this)
                                                    ) 
                                                }

                                            </div>
                                        </td>
                                    </tr>
                                </table>
                                <div className='device-select-facility-buttons'>
                                    <SearchPopupButton
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel="Select Facility"
                                                        query={this.props.securityObject.httpServer + "api/get/facility?"}
                                                        columns={[
                                                                //{ key: 'id', title:"Facility id", width :20 }
                                                                { key: 'display_facility_name', title:"facility name", width :40 }
                                                                ,{ key: 'display_address', title:"facility address", width :40 }
                                                                ,{ key: 'display_city', title:"city", width :40 }
                                                                ,{ key: 'display_state', title:"state", width :40 }
                                                                ,{ key: 'display_zip', title:"zip", width :40 }
                                                                ]}
                                                        onClick={this.selectFacility.bind(this)}
                                                    >
                                                </SearchPopupButton>
                                                <SearchPopupButton
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel="Select Hub"
                                                        query={this.props.securityObject.httpServer + "api/get/hubSearch?"}
                                                        columns={[
                                                                { key: 'hostname', title:"hostname", width :40 }
                                                                ,{ key: 'display_name', title:"name", width :40 }
                                                                ,{ key: 'facility_name', title:"facility name", width :40 }
                                                                ]}
                                                        onClick={this.selectHub.bind(this)}
                                                    >
                                                </SearchPopupButton>

                                </div>
                            </div>
                        </TabPanel >
                        <TabPanel >
                            <SearchTable
                                securityObject={this.props.securityObject}
                                query={this.props.securityObject.httpServer + `api/get/orderDetail?sql=(item_identifier='${this.state.selectedObject.mac}' or item_identifier='${this.state.selectedObject.serial_number}')`}
                                ref={this.shipTableRef}
                                openSearched={true}
                                columns={[
                                        { key: 'order_type', title:"order type", width :40 }
                                        ,{ key: 'order_id', title:"order id", width :40 }
                                        ,{ key: 'last_updated_time', title:"last updated", width :40 } 
                                        ,{ key: 'item_identifier', title:"identifier", width :40 }
                                        ,{ key: 'item_style', title:"style", width :40 }
                                        ,{ key: 'note', title:"note", width :40 }
                                        ,{ key: 'facility_name', title:"facility", width :40 }
                                        ]}
                                tableHeight="40vh"
                                hideSearch="Y"
                            >
                            </SearchTable>                            
                        </TabPanel >
                    </Tabs>  
              
                </Popup>               
            </div>
        ):"";
    }

    afterClosePopup(){
        try{
            this.deviceTableRef.current.queryData();
        } catch (ex){
        }
    }
  
    showEditScreen(rowData){
        let postObj={id:rowData.id}; 
        //, facility_id:this.props.facilityId, facility_name:this.props.facilityName
        if(rowData.id===-1){
            if(this.props.facilityId){
                postObj.facility_id=this.props.facilityId;
                postObj.note="Firmware:";
                rowData.facility_id=postObj.facility_id;
                rowData.facility_name=this.props.facilityName;
                rowData.note=postObj.note;
            }  else {
                postObj.facility_id=1;  //set to inventory
                rowData.facility_id=1;  //set to inventory
                rowData.facility_name="Wave Inventory";
            }
        }
        if(rowData.type){
            postObj.type=rowData.type;
        } else {
            postObj.type=this.state.device_type_list[0].value
        }
        this.setState({
            selectedObject:rowData,
            postObj:postObj
        })

        // set focus add key presses
        functions.sleep(500).then(() => {
            if(document.getElementById("inputTableAddEditmac")){
                document.getElementById("inputTableAddEditmac").focus();
                // hide fields
                document.getElementById("spanTableAddEditsearch_column").className="hidden";
                document.getElementById("labelTableAddEditsearch_column").className="hidden";

                // add keypress
                //document.getElementById("inputTableAddEditmac").onkeydown=this.onKeyDownEvent.bind(this);
                //document.getElementById("inputTableAddEditserial_number").onkeydown=this.onKeyDownEvent.bind(this);
                //document.getElementById("inputTableAddEditnote").onkeydown=this.onKeyDownEvent.bind(this);
                //document.getElementById("labelTableAddEditfacility_id").className="hidden"    
                //document.getElementById("inputTableAddEditfacility_id").className="hidden"
                document.getElementById("inputTableAddEdittype").onchange=this.changeType.bind(this);
            }    
        });
    }
    // close the popup
    closePopup(){
        if(this.state.edited){
            if(window.confirm("Are you sure you want to exit without saving")){
                this.setState({
                    selectedObject:false
                });
            }
        } else {
            this.setState({
                selectedObject:false
            });
        }
    }    
    changeFieldValue(event) {
        if(event.currentTarget.name==='mac'){
            functions.normalizeInputForMacAddress(event)
        }  
        if(event.currentTarget.name==='serial_number'){
            functions.normalizeInputForSerialNumber(event)
        }                
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        let postObj=this.state.postObj;
        postObj[key]=val.replace(/<.*>/, '');;
        document.getElementById("inputTableAddEdit"+key).value=this.state.postObj[key];
        this.setState({
            edited:true,
            postObj:postObj
        })
        document.getElementById("message").innerHTML="";
        if(val.length===17 && key==="mac"){
            document.getElementById("inputTableAddEditserial_number").focus();
        }
        if (val.indexOf("<Save>")>=0){
            this.saveChanges();
        }
        //alt a
        if (val.indexOf("<SaveAdd>")>=0){
            this.saveChangesAdd();
        }
        //alt c
        if (val.indexOf("<Cancel>")>=0){
            this.closePopup();
        }
        //alt r
        if (val.indexOf("<RemoveData>")>=0){
            this.removeData();
        }
    }  
    saveChanges(){
        
        // save upper case
        let postObj=this.state.postObj;
        if(postObj.mac){
            postObj.mac=postObj.mac.toUpperCase();
            this.setState({postObj:postObj});
        }
        if(this.validateScreen()){
            let thisApp=this;
            db.saveData( this.props.securityObject
                , postObj
                ,"api/updateDevice"
                , this.afterSave.bind(thisApp)
            );  
        }
    }
    afterSave(res){
        if(res.resultCode===1){
            this.setState({
                edited:false
            })
            this.closePopup();
        } else {
            this.barcodeScannerAlert(JSON.stringify(res));
        }
    }
    saveChangesAdd(){
        if(this.validateScreen()){
            db.saveData( this.props.securityObject
                , this.state.postObj
                ,"api/updateDevice"
                , this.afterSaveAdd.bind(this)
            );  
        }
    }
    afterSaveAdd(res){
        if(res.resultCode===1){
            let postObj= this.state.postObj;
            postObj.mac=undefined;
            postObj.serial_number=undefined;
            this.setState({
                edited:false
                ,postObj:postObj
            })

            // display the saved message
            document.getElementById("message").innerHTML=
                document.getElementById("inputTableAddEditmac").value
                +" / "
                +document.getElementById("inputTableAddEditserial_number").value
                +" Data Saved";

            // reset values on screen for mac address
            document.getElementById("inputTableAddEditmac").value="";
            document.getElementById("inputTableAddEditserial_number").value=""
            
            this.updateNote();

            this.showEditScreen({
                id:-1,
                note:document.getElementById("inputTableAddEditnote").value,
                type:document.getElementById("inputTableAddEdittype").value
            })
        } else {
            this.barcodeScannerAlert(JSON.stringify(res));
        }
    }


    selectFacility(rowData){
        document.getElementById("inputTableAddEditfacility_id").value=rowData.id;
        document.getElementById("spanTableAddEditfacility_name").innerHTML=rowData.display_facility_name;
        let postObj=this.state.postObj;
        postObj.facility_id=rowData.id;
        this.setState({
            edited:true,
            postObj:postObj
        })     
    }
    selectHub(rowData){
        document.getElementById("inputTableAddEdithub_id").value=rowData.id;
        document.getElementById("spanTableAddEdithostname").innerHTML=rowData.hostname;
        document.getElementById("spanTableAddEdithub_display_name").innerHTML=rowData.display_name;
        let  postObj=this.state.postObj
        postObj.hub_id=rowData.id;
        if(this.state.selectedObject.facility_id!==rowData.facility_id){
            if (window.confirm(`Facilities do not match.  Would you like to change the facility from "${this.state.selectedObject.facility_name}" to "${rowData.facility_name}"?`)){
                document.getElementById("inputTableAddEditfacility_id").value=rowData.facility_id;
                document.getElementById("spanTableAddEditfacility_name").innerHTML=rowData.facility_name;
                postObj.facility_id=rowData.facility_id;        
            }
        }
        this.setState({
            edited:true,
            postObj:postObj
        })     
    }

    removeData(){
        document.getElementById("inputTableAddEditmac").value="";
        document.getElementById("inputTableAddEditserial_number").value="";
        document.getElementById("inputTableAddEditmac").focus();
    }

    // https://sps-support.honeywell.com/s/article/How-to-create-standalone-bar-codes-for-ALT-1-char
    /*
    The simple way to create them is using the BarCode Builder program, using the ASCII Control Characters, then adding the required letter.
    For example: ALT+T
    In BarCode Builder select Aztec or Code 128, then click on Control Chars, select STX (0x02 02) double click on it and then click OK. 
    After that add 'T' or 't' in the code. It will result with the ALT+T standalone bar code.
    For CTRL, select ENQ (0x05 05) and add also the required letter.
    There is no way to create a bar code which is containing the control key >Shift<!
*/

    onKeyDownEvent(e){
        //alt s
        if ((e.altKey && e.keyCode === 83)){
            this.saveChanges();
        }
        //alt a
        if ((e.altKey && e.keyCode === 65)){
            this.saveChangesAdd();
        }
        //alt c
        if ((e.altKey && e.keyCode === 67)){
            this.closePopup();
        }
        //alt r
        if ((e.altKey && e.keyCode === 82)){
            this.removeData();
        }
    }
    changeType(event){
        this.updateNote();
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        let postObj=this.state.postObj;
        postObj[key]=val;
        this.setState({postObj:postObj})
    }
    updateNote(){
        //if(document.getElementById("inputTableAddEdittype").value==="ab"){
        //    document.getElementById("inputTableAddEditnote").value="Firmware:\n"
        //}
    }
    validateScreen(){
        let val=document.getElementById("inputTableAddEditmac").value;
        if(val===""){
            return true;
        } else if(val.indexOf(":")<0){
            this.barcodeScannerAlert("Invalid mac address");
            return false;
        } else if (! /^[0-9a-f]{1,2}([.:-])[0-9a-f]{1,2}(?:\1[0-9a-f]{1,2}){4}$/i.test(val)){
            this.barcodeScannerAlert("Invalid mac adderss");
            return false;            
        }
        return true;
    }
    barcodeScannerAlert(msg){
        alert(msg);
    }
    downloadCSV(){
        let data = "mac,serial_number,type\n";
        this.deviceTableRef.current.searchTableRef.current.state.data.forEach( dev=>{
            data += this.noNull(dev.mac) + ","
                + this.noNull(dev.serial_number) +","
                + this.noNull(dev.type) +","
                + "\n";
        })
        let type = "text/csv", name = "devices.csvh";
        functions.downloader(data, type, name)        
    }
    noNull(val){
        if(val==null){
            return "";
        }
        return val;
    }

    selectDeviceToMoveHere(rowData){
        if( window.confirm(
            `Are you sure you want to move device "${rowData.serial_number}"/"${rowData.mac}" to facility "${this.props.facilityName}"?`)){
                let update={id:rowData.id, facility_id:this.props.facilityId};
                        // save the data
                let obj=this.state.selectedObject;
                let thisObj=this;
                db.saveData( this.props.securityObject
                    , update
                    ,"api/updateDevice"
                    , function(result){
                        thisObj.showEditScreen(obj);
                    });

            }
    }

    selectMac(rowData){
        document.getElementById("inputTableAddEditmac").value=rowData.mac;
        let postObj=this.state.postObj;
        postObj.mac=rowData.mac;
        this.setState({
            edited:true
            ,postObj:postObj
        })
    }
}

